<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="80%">
      <v-card>
        <v-card-text v-if="handbookDocument !== ''" class="pa-0">
          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <div
            class="pa-0 elevation-1"
            :style="{
              height: isMobile ? 'auto' : '75vh',
              minHeight: isMobile ? '300px' : '600px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div
                v-if="isMobile"
                class="pa-12 text-center d-flex flex-column align-center justify-center"
              >
                <v-icon size="100" color="primary lighten-4"
                  >mdi-file-pdf-box</v-icon
                >
                <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
                  Handbook Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  The handbook is ready. Since you are on a mobile device, please
                  use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Handbook
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                :src="pdfUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="Handbook Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </div>
        </v-card-text>
        <v-card-text v-else>
          <p class="font-weight-black mt-3">Nothing to Preview</p>
        </v-card-text>
        <v-divider />
        <v-card-actions class="handbookcardactions">
          <v-btn
            @click="$router.back()"
            dense
            class="mx-3 error lighten-4 error--text text--darken-4"
          >
            <v-icon class="mx-2">mdi-arrow-left</v-icon>
            Back
          </v-btn>

          <v-spacer />

          <v-form
            v-model="isValid"
            ref="submitForm"
            v-if="!checkIfHandbookIsRead(handbook.code)"
          >
            <div class="d-flex justify-space-between">
              <v-checkbox
                class="mx-5"
                color="primary"
                v-model="formData.hasRead"
                label="I have Read the Employee Document"
                :rules="rules.required"
              ></v-checkbox>
              <div>
                <v-btn
                  class="handbook--btn mt-3 mr-5"
                  color="primary"
                  @click.prevent="submit"
                >
                  Submit
                </v-btn>
              </div>
            </div>
          </v-form>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style>
.handbook--btn > .v-btn__content {
  font-size: 16px;
  text-transform: none;
}
.handbookcardactions {
  position: sticky;
  bottom: 0;
  z-index: 999;
  background-color: #fff;
}
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
<script>
import FileMixin from "@kinetics254/cassandra-base/mixins/FileMixin.js";

export default {
  name: "HandBookCard",
  mixins: [FileMixin],
  data: function () {
    return {
      pdfUrl: null,
      numPages: undefined,
      agree: false,
      isValid: false,
      dialog: true,
      formData: {
        readHandbook: null,
        employeeNo: "",
        handbookCode: "",
        hasRead: false,
      },
    };
  },

  computed: {
    rules() {
      return {
        required: [(v) => !!v || "This field is required"],
      };
    },
    HandbookLogs() {
      return this.$store.getters["handbook/allReadhandbooks"];
    },
    employeeData: function () {
      const employee = this.$store.getters["profile/employee"][0];
      return employee || {};
    },
    handbook() {
      const handbooks = this.$store.getters["handbook/handbook"];
      return handbooks
        ? handbooks.filter((d) => d.code === atob(this.$route.params.code))[0]
        : {};
    },
    handbookDocument() {
      return this.handbook
        ? process.env.VUE_APP_FILE_API + this.handbook.handbook
        : "";
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    employeeData() {
      this.formData.readHandbook = this.employeeData.readHandbook;
    },
    handbookDocument: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.pdfUrl = newValue;
        }
      },
    },
  },
  methods: {
    submit() {
      if (!this.isValid) {
        this.$refs.submitForm.validate();
      } else {
        const data = {
          handbookCode: this.handbook.code,
          employeeNo: this.employeeData.number,
          hasRead: this.formData.hasRead,
        };
        this.$store.dispatch("handbook/readHandbook", { ...data });
      }
    },
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
    checkIfHandbookIsRead(val) {
      return this.HandbookLogs.find((d) => d.handbookCode === val)
        ? this.HandbookLogs.find((d) => d.handbookCode === val).hasRead
        : false;
    },
  },
  mounted() {
    this.$store.getters["handbook/allReadhandbooks"];
  },
};
</script>
